import { AttendanceExtraHoursRange } from 'generated/resources/graphql'

class ExtraHoursRangeUtils {
  static isDefault(extraHoursRange: Pick<AttendanceExtraHoursRange, 'default'>) {
    return extraHoursRange.default
  }

  static customExtraHoursRanges<T extends Pick<AttendanceExtraHoursRange, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.filter((range) => !this.isDefault(range))
  }

  static defaultExtraHoursRanges<T extends Pick<AttendanceExtraHoursRange, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.find((range) => this.isDefault(range))
  }

  static hasCustomExtraHoursRanges<T extends Pick<AttendanceExtraHoursRange, 'default'>>(
    extraHoursRanges: T[]
  ) {
    return this.customExtraHoursRanges(extraHoursRanges).length > 0
  }

  static hasUnlimitedExtraHourRanges<T extends Pick<AttendanceExtraHoursRange, 'unlimited'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.some((range) => this.isUnlimited(range))
  }

  static hasTimeOffRanges<T extends Pick<AttendanceExtraHoursRange, 'poolType'>>(
    extraHoursRanges: T[]
  ) {
    return extraHoursRanges.some((range) => this.isTimeOff(range))
  }

  static isTimeOff(extraHoursRange: Pick<AttendanceExtraHoursRange, 'poolType'>) {
    return extraHoursRange.poolType === 'timeoff'
  }

  static isUnlimited(extraHoursRange: Pick<AttendanceExtraHoursRange, 'unlimited'>) {
    return extraHoursRange.unlimited
  }

  static sortedCustomByFromMinute<
    T extends Pick<AttendanceExtraHoursRange, 'default' | 'fromMinute'>
  >(extraHoursRanges: T[]) {
    return this.customExtraHoursRanges(extraHoursRanges).sort((a, b) => a.fromMinute - b.fromMinute)
  }
}

export default ExtraHoursRangeUtils
